export default {
  component: {
    OrderConfirmation: 'ORDER CONFIRMATION',
    OrderCancellation: 'ORDER CANCELLATION',
    OTPConfirmation: 'OTP Confirmation',
    CustodyCode: 'Custody Code',
    SubInvestmentAccount: 'Sub-Investment Account',
    Ticker: 'Ticker',
    Type: 'Type',
    Price: 'Price',
    Volume: 'Volume',
    VolumeCancel: 'Volume Cancel',
    Value: 'Value',
    Confirm: 'Confirm',
    Cancel: 'Cancel',
    Contact: 'Please enter the OTP code sent to your device ',
    InputOTP: 'Enter the OTP code',
  },
};
